import { di } from 'react-magnetic-di';
import { createSelector } from 'react-sweet-state';
import { isScreenTabsSupportEnabled } from '../../../view-configuration';
export var selectReadyPublicDataForOnInit = createSelector(function (_, props) {
  return props.viewType;
}, function (state) {
  return state.formData;
}, function (state) {
  return state.numberOfSupportedFields;
}, function (state) {
  return state.screenTabs;
}, function (state) {
  return state.experienceDataIsLoading;
}, function (viewType, formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading) {
  if (formData !== null && !isScreenTabsSupportEnabled(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) {
    return {
      formData: formData,
      screenTabsData: []
    };
  }
  if (formData !== null && screenTabsData !== null && isScreenTabsSupportEnabled(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) {
    return {
      formData: formData,
      screenTabsData: screenTabsData
    };
  }
  return null;
});